import { useEffect } from 'react'
import { style, stylesheet, classes } from 'typestyle'

/* Hooks ======================================================================================== */
import useBoolean from '../../../__aeki__/hooks/use-boolean'

/* Styles ======================================================================================= */
import { f24i } from '../../../__aeki__/styles/styleset/font-size/f24i'

/* <Marker /> =================================================================================== */
export const Marker = (props: {
  style?: any
  index?: number
  parentNode?: any
  children?: any
  focused?: boolean
  isAnimating?: boolean
}) => {
  const [hovered, $hovered] = useBoolean(false)
  const [mounted, $mounted] = useBoolean(!props.isAnimating)

  let timeout: any
  useEffect(() => {
    clearTimeout(timeout)

    timeout = setTimeout(() => {
      $mounted.set(true)
    }, 500)

    return () => {
      $mounted.set(false)
      clearTimeout(timeout)
    }
  }, [])

  const handleMouseEnter = () => $hovered.set(true)
  const handlerMouseLeave = () => $hovered.set(false)

  return (
    <div
      className={classes(
        STYLES.container,
        props.focused && STYLES.containerFocused,
        style(props.style),
      )}
      id={`google-map-marker-${props.index}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handlerMouseLeave}
    >
      <div className={STYLES.containerIcon}>
        <span className={classes('material-icons-two-tone', f24i)}>child_care</span>
      </div>
      {props.children.length > 1 && (
        <span className={classes(STYLES.textStackedSize, hovered && STYLES.textStackedSizeHovered)}>
          {props.children.length}
        </span>
      )}
    </div>
  )
}

const STYLES = stylesheet({
  container: {
    alignItems: 'center',
    backgroundColor: '#61ade2',
    borderRadius: '50%',
    boxShadow: '1px 1px 5px 2px rgba(0, 0, 0, 0.09)',
    display: 'flex',
    fontSize: 11,
    height: 30,
    justifyContent: 'center',
    position: 'relative',
    textAlign: 'center',
    transition: '0.2s ease all',
    width: 30,
    $nest: {
      '&:hover': {
        backgroundColor: '#61ade2',
        marginTop: -2.5,
        zIndex: 5,
      },
      '&:focus': {
        backgroundColor: '#61ade2',
        marginTop: -2.5,
        zIndex: 5,
      },
    },
  },
  containerFocused: {
    backgroundColor: '#61ade2',
    zIndex: 5,
  },
  containerIcon: {
    alignItems: 'center',
    // background: '#61ade2',
    borderRadius: '50%',
    display: 'flex',
    height: 17,
    justifyContent: 'center',
    width: 17,
  },
  textStackedSize: {
    background: '#ffcd15',
    borderRadius: 7,
    color: 'black',
    fontWeight: 700,
    height: 14,
    position: 'absolute',
    right: -4,
    top: -4,
    transition: '0.2s ease all',
    width: 14,
  },
  textStackedSizeHovered: {
    top: -8,
  },
})
